import { call, put, takeEvery } from "redux-saga/effects";
import { _ADMINISTRATOR_API_ENDPOINTS, SUCCESS } from "../../../constants/AppConstants";
import * as actionTypes from '../../../constants/ActionTypes/AdminPortal/AdminUsers';
import { _CALLGETAPI } from "../../../api/apiHandler";
import i18next from "i18next";

function _VALIDATEUSER(emailID) {
    const endpoint = _ADMINISTRATOR_API_ENDPOINTS.MANAGE_ADMIN_USER.VALIDATE_NEW_USER_BY_EMAIL;

    const payload = {
        params:{
            emailId: emailID
        }
    }

    return _CALLGETAPI(endpoint, payload)
        .then(response => {
            return response;
        })
        .catch((error) => {
            throw error;
        });
}

function* handleError(msg = null) {
    yield put({
        type: actionTypes.ADMIN_USERS_VALIDATE_ERROR,
        message: (msg) ? msg : i18next.t('Admintranslation:ADMIN_COMMON_ERRORS.TECHNICAL_ERROR')
    });
}

function* handleInfo(action) {
    try {
        const emailID = (action.emailID) ? action.emailID : null;
        if (emailID) {
            const result = yield call(_VALIDATEUSER, emailID);
            if (result) {
                if (result.actionStatus.toUpperCase() === SUCCESS) {
                    // enable Submit button
                    yield put({ type: actionTypes.ADMIN_USERS_VALIDATE_SUCCESS, data: result });
                } else {
                    // display error message received from api response
                    yield* handleError(result.actionMessage);
                }
            } else {
                yield* handleError();
            }
        
        } else {
            yield* handleError();
        }
    } catch (e){
        yield* handleError();
    }
}

function* AdminUser_VALIDATE() {
    yield takeEvery(actionTypes.ADMIN_USERS_VALIDATE_INIT, handleInfo);
}

export default AdminUser_VALIDATE;